import { Dropdown } from 'semantic-ui-react';

export default Dropdown;
